import FieldEditor from "editor/FieldEditor";
import ContentAdminEditor from "content/adminEditors/ContentAdminEditor";
import Ajax from "base/Ajax";


class ContentAdminEditorCategory extends ContentAdminEditor {

    static get_name() {
        return 'Category';
    }

    getInputType() {
        return '11';
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        let prom;
        if (this.getSettingValue('categories')) {
            prom = Promise.resolve(this.getSettingValue('categories'));
        } else if (this.value.id) {
            prom = Ajax.get("content", 'categories/' + this.value.id)
        } else {
            this.setSettingValue('categories', []);
            prom = Promise.resolve(this.getSettingValue('categories'));
        }

        return prom.then((categories) => {
            this.setSettingValue('categories', categories);
            return [
                {
                    name: 'slug',
                    label: 'Slug',
                    type: 'text'
                },
                {
                    label: 'Options',
                    type: 'group',
                    children: [
                        {
                            name: 'allowMultiple',
                            label: 'Allow more than one',
                            type: 'checkbox',
                            default: true
                        },
                        {
                            name: 'allowAdding',
                            label: 'User can add categories',
                            type: 'checkbox',
                            default: true
                        },
                        {
                            name: 'required',
                            label: 'Required',
                            type: 'checkbox',
                            default: false
                        }
                    ]
                },
                {
                    label: "Categories",
                    name: 'categories',
                    type: "content/admin/category/categories",
                    categories: categories
                }
            ];
        })
    }
}

FieldEditor.register_editor('content/admin/category', ContentAdminEditorCategory);

export default ContentAdminEditorCategory;
